<template>
  <div id="Cool9Second">
    <c-block-box title="便捷面板（责任人：张亮）" class="second-floor-item-1">
      <div class="content-1 pad-20">
        <div class="top">
          <CoolSmallCard v-for="item in 4" class="item-small"></CoolSmallCard>
        </div>
        <div class="bot">
          <div class="rangking-1">
            <div class="title">常用功能排行</div>
            <DomeEchartWrap id="rangking-1" ref="rangking-1"></DomeEchartWrap>
          </div>
          <div class="rangking-2">
            <div class="title">常用功能排行</div>
            <DomeEchartWrap id="rangking-2" ref="rangking-2"></DomeEchartWrap>
          </div>
        </div>
      </div>
    </c-block-box>
    <c-block-box title="便捷面板（责任人：张亮）" class="second-floor-item-2">
      <div class="content-2 pad-20">
        <div class="content-2__left">
          <div class="content-2__left-top">
            <CoolSmallCard v-for="item in 2" class="item-small"></CoolSmallCard>
          </div>
          <div class="content-2__rangking-3">
            <div class="title">常用功能排行</div>
            <DomeEchartWrap id="rangking-3" ref="rangking-3"></DomeEchartWrap>
          </div>
        </div>
        <div class="content-2__right">
          <div class="title">常用功能排行</div>
          <DomeEchartWrap></DomeEchartWrap>
        </div>
      </div>
    </c-block-box>
    <c-block-box title="应急广播（责任人：赵梓淞）" class="second-floor-item-3">
      <div class="content-3 pad-20">
        <div class="top"></div>
        <div class="bot"></div>
        <div class="map"></div>
      </div>
    </c-block-box>
    <c-block-box title="主动服务（责任人：王腾龙）" class="second-floor-item-4">
      <div class="content-4 pad-20">
        <div class="content-4__top"></div>
        <div class="content-4__bot"></div>
      </div>
    </c-block-box>
  </div>
</template>

<script>
import CoolSmallCard from './CoolSmallCard.vue'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import { RankingCommonEchartOp } from './js/SecondFloor'
import common from '@/mixins/common.js'
export default {
  mixins: [common],
  name: 'Cool9Second',
  components: {
    CoolSmallCard,
    DomeEchartWrap
  },
  props: [],
  data () {
    return {}
  },
  computed: {},
  created () {},
  mounted () {
    this.$refs['rangking-1'].setEchartOption(RankingCommonEchartOp({ v: this }))
    this.$refs['rangking-2'].setEchartOption(RankingCommonEchartOp({ v: this }))
    this.$refs['rangking-3'].setEchartOption(RankingCommonEchartOp({ v: this }))
  },
  watch: {},
  methods: {}
}
</script>

<style scoped lang="stylus">
#Cool9Second {
  display: flex;
  flex-wrap: wrap;
}

.content-1 {
  width: 445px;
  .top {
    display: flex;
    flex-wrap: wrap;
  }
}
.content-1,.content-2,.content-3,.content-4
  height 250px
  overflow hidden
.content-1
  .bot
    height 140px
    width 100%
    display: flex;
    overflow hidden
    margin-top: 20px
    .title
      color rgba(255, 255, 255, 0.8)
      font-size: 14px
    .rangking-1,.rangking-2
      height 100%
      display: flex;
      flex-direction: column;
      flex: 1 0 50%
    #rangking-1,rangking-2
      flex-grow: 1
    .rangking-1
      margin-right: 20px

.content-2
  display: flex;
  .content-2__left,.content-2__right
    flex-grow: 1
    flex-shrink: 0
    width 320px
  .title
    color rgba(255, 255, 255, 0.8)
    font-size: 14px

.content-2__left-top
  display: flex
.pad-20
  padding: 20px

.content-2__left
  display: flex
  flex-direction: column
  .content-2__rangking-3
    flex-grow: 1
</style>
